<script setup>
import { computed } from 'vue'
import { useODataSource } from '@/composables/data-grid'
import { useRegistryStore } from '@/stores/registry.store'

import GridDropDownBox from '@/components/shared/GridDropDownBox.vue'

const props = defineProps({
  data: {
    type: Object,
    default: null,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  exclude: {
    type: Number,
    required: false,
  },
  supplier_type_code: {
    type: String,
    required: false,
  },
})

const registryStore = useRegistryStore()

const computedDataSource = computed(() => {
  const url = registryStore.api.getAbsoluteUrl() + registryStore.api.suppliersUrl

  const ds = useODataSource(url, {
    searchExpr: ['name', 'code'],
  })

  const filters = []

  if (props.supplier_type_code != null) {
    filters.push(['supplier_type_code', '=', props.supplier_type_code])
  }
  if (props.exclude != null) {
    filters.push(['id', '<>', props.exclude])
  }

  let finalFilter = null

  if (filters.length === 1) {
    finalFilter = filters[0]
  } else if (filters.length > 1) {
    finalFilter = filters.reduce((acc, current, idx) => {
      if (idx === 0) return current
      return [acc, 'and', current]
    })
  }

  ds.filter(finalFilter)
  return ds
})

</script>

<template>
  <grid-drop-down-box
    :disabled="props.disabled"
    :value="props.data.value"
    :data-source="computedDataSource"
    :columns="[
      { dataField: 'code', caption: $t('common.code'), width: '5rem' },
      { dataField: 'name', caption: $t('common.name'), sortOrder: 'asc' },
      { dataField: 'vat_number', caption: $t('common.vatNumber') },
      { dataField: 'address.city__name', caption: $t('common.city') },
      { dataField: 'address.street', caption: $t('common.street') },
    ]"
    :drop-down-options="{ width: '60rem', height: '25rem' }"
    @value-changed="(e) => props.data.setValue(e)"
  />
</template>
